"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonUpAccountsFilter = void 0;
/**
 * This filter is used to skip LessonUp accounts when query the users collection
 */
exports.LessonUpAccountsFilter = { 'emails.address': { $not: /(@lessonup|@q42)/ } };
//# sourceMappingURL=lessonup.utils.js.map